<template>
  <div>
    <va-card>
      <template slot="header">
        <div class="va-card__header-title" color="secondary">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / {{ $t('menu.regions') }}
        </div>
        <div class="va-card__header-actions">
          <va-button small icon="fa fa-plus" to="/bolge/ekleme">{{ $t('tables.actions.create') }}</va-button>
        </div>
      </template>

      <div class="row align--center">
        <div class="flex xs12 md6"></div>
        <div class="flex xs12 md3 offset--md3"></div>
      </div>

      <va-data-table
        :fields="fields"
        :data="items"
        :loading="loading"
        api-mode
      >
        <template slot="type" slot-scope="props">
          <va-icon :name="getTypeIcon(props.rowData)"/>
        </template>

        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('tables.actions.translate')} ` + (props.rowData.name.en ? `${$t('tables.actions.edit')}` : `${$t('tables.actions.add')}`)" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small :color="props.rowData.name.en ? 'info' : 'gray'" class="ma-0" @click.stop="buttonAsHref('/bolge/'+props.rowData.id+'/ceviri')">
              {{ $t('tables.actions.english') }}
            </va-button>
          </va-popover>
          <va-popover :message="`${$t('tables.actions.edit')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="info" icon="fa fa-pencil" @click.stop="buttonAsHref('/bolge/'+props.rowData.id+'/duzenleme')"/>
          </va-popover>
          <va-popover :message="`${$t('tables.actions.destroy')}`" placement="bottom" color="dark" :disabled="isMobile">
            <va-button flat small color="warning" icon="fa fa-trash" @click.stop="confirmDeleteRegion(props.rowData)"/>
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-pagination
      v-model="pages.current_page"
      :visible-pages="3"
      :pages="pages.last_page"
      class="mt-3"
      :small="true"
      color="secondary"
    />
  </div>
</template>

<script>
import regionServices from '../../services/api/region'
import responseMixin from '../../services/api/response'
import helperMixin from '../../services/helper'
export default {
  mixins: [responseMixin, helperMixin],
  data () {
    return {
      isMobile: false,
      loading: false,
      items: [],
      pages: {
        current_page: 1,
        last_page: 1
      }
    }
  },
  computed: {
    fields () {
      return [{
        name: 'name_readable',
        title: this.$t('tables.headings.region.name'),
        width: '40%',
      }, {
        name: '__slot:type',
        title: this.$t('tables.headings.region.type'),
      }, {
        name: 'city.name',
        title: this.$t('tables.headings.region.city'),
      }, {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    }
  },
  watch: {
    'pages.current_page': function(val) {
      let q = {};
      q.sayfa = val;
      this.$router.push({ path: '/bolge/listesi', query: q });
      this.getRegions(val);
    },
    '$route.query'(val) {
      this.splitQuery(val);
    }
  },
  methods: {
    async getRegions(page=1, filter = {}){
      this.loading = true;

      filter.include = 'city';
      filter.page = page;
      filter.limit = 15;
      filter.sort = '-id';

      const result = await regionServices.get('', {
          params: filter
        });
      this.loading = false;
      if(result.error){
        this.items = [];
        return ;
      }
      this.items = result.data.data;
      this.pages = result.data.meta;
    },
    getTypeIcon (region) {
      if (region.type === 'district') {
        return 'fa fa-map-marker'
      }

      if (region.type === 'airport') {
        return 'fa fa-plane'
      }

      return 'fa fa-map-marker'
    },
    async deleteRegion(id) {
      const res = await regionServices.delete(id);
      if(res.error){
        this.responseToast('DELETE', 'error', res);
        return ;
      }
      this.responseToast('DELETE', 'success');
      this.getRegions(this.pages.current_page);
    },
    confirmDeleteRegion(item) {
      this.$dialog
        .confirm( item.name_readable + ' isimli bölgeyi silmek üzeresiniz, onaylıyor musunuz?', {
          loader: true,
          okText: "Sil",
          cancelText: "Vazgeç"
        })
        .then(dialog => {
          this.deleteRegion(item.id);
          dialog.close();
        })
        .catch(dialog => {
          dialog.close();
        });
    },
    splitQuery(q) {
      let page = 1;
      if(q.sayfa) {
        page = parseInt(q.sayfa);
      }
      this.getRegions(page);
    }
  },
  created() {
    this.isMobile = this.checkIsMobile();
    this.splitQuery(this.$route.query);
  }
}
</script>
